export default "__VITE_ASSET__Kv6e9WsH__"